import React from 'react';
import { Outlet } from 'react-router-dom';
import ClientHeader from '../ClientHeader';
import ClientFooter from '../ClientFooter';
import ChatWidget from '../ChatWidget';

const ClientLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <ClientHeader />
      <main className="flex-1 relative">
        <Outlet />
      </main>
      <ClientFooter />
      <ChatWidget />
    </div>
  );
};

export default ClientLayout;
